<template>
  <div id="app">
	<Header :cid="Cid"></Header>
    <div class="banner"><img src="../assets/images/index_10.png" /></div>
	<div class="idx-1200-box page-1200-box">
      <div class="page-nav-lef">
      		   <div class="page-nav-lef-head">{{classInfo.classname}}</div>
      		   <ul class="menu-box">
      			 <li v-for="(item,index) in classChild" :key="item.id"><a :href="item.linkurl">{{item.classname}}</a> <img src="../assets/images/right.png" /></li> 
      		   </ul>
      		   <a href=""><img class="contact-pic" src="../assets/images/index_10.png" alt="客服" /></a>
      </div>
	   <div class="page-rig-conte">
		   <div class="page-rig-conte-head">
			   <p>园陵景观</p>
			   <div class="nav-site">
				  <p>您当前位置：</p>
				   <a href="/index">首页&gt;</a>
				   <a href="/garden_show">{{classInfo.classname}}&gt;</a>
			   </div>
		   </div>
		   <div class="page-rig-conte-picbox">
			 <a  v-for="item in listData" :key="item.id" href=""><div class="page-rig-conte-picbox-one">
			  <img :src="item.picurl" />
			 </div></a>
		   </div>
		   <div class="page-bott-pager">
			  <el-pagination background @size-change="handleSizeChange"
			  @current-change="handleCurrentChange"
			  :current-page.sync="page"
			  :page-size="limit"
			  layout="sizes, prev, pager, next"   :total="total"></el-pagination>
		   </div>
	   </div>
	</div>
	<Footer :Idx_bott_wxqrcode="idx_bott_wxqrcode" :Idx_bott_logo="idx_bott_logo"  :Classdata="classData" :Copyright="copyright" :Recordno="record_No"></Footer>
  </div>
</template>
   
<script>
import { InfoListApi} from '../api/info_list'
import {getInfoClassIndex } from '../api/info_class'
import { InfoApi } from '../api/info'
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
 components: {
    Header,
	Footer
  },
  mixins: [Header, Footer],
  data () {
      return {
          listData:[],
		  classInfo:{},
		  classChild:[],
		  Cid:4,
		  page:1,
		  limit: 10,
		  total:0,
		  sid:4,
      }
  },
  mounted() {
      const _this = this;
  	  var sid = this.getQueryString('sid');
  	  this.sid = sid==undefined ? this.sid : sid;
  	  console.log(this.sid)
      this.$nextTick(() => {
      })
      getInfoClassIndex(this.Cid).then(res => {
  	  	console.log(res)
  	  	if(res.status==200){
  	  		console.log(111)
  	  		_this.classInfo = res.data.info[0] || {};
  			_this.classChild = res.data.child_list || [];
  	  	}
  	  }).catch(res => {
  	  	_this.$notify({
  	  	  title: 'It works!',
  	  	  type: 'success',
  	  	  message: res,
  	  	  duration: 5000
  	  	})
  	  })  
  	  
  	 this.getData({page:this.page,limit:this.limit,classid:this.sid}); 
  },
  methods: {
    startHacking () {
      this.$notify({
        title: 'It works!',
        type: 'success',
        message: 'We\'ve laid the ground work for you. It\'s time for you to build something epic!',
        duration: 5000
      })
    },
	getData(data){
		var _this = this;
		InfoListApi(data).then(res => {
			console.log(res)
			if(res.status==200){
				console.log(111)
				_this.listData = res.data.list;
			    _this.total = res.data.count;
			}
		}).catch(res => {
			_this.$notify({
			  title: 'It works!',
			  type: 'success',
			  message: res,
			  duration: 5000
			})
		})  
	},
  }
}
</script>
  
<style>
#app {
  font-family: Helvetica, sans-serif;
  text-align: center;
}
</style>
<style>
	@import url("/src/assets/style/style.css");
</style>


// WEBPACK FOOTER //
// src/pages/garden_show.vue